<template>
    <auth-layout :isPlain="true" :progress="0" :isProgressBarHidden="true">
        <common-page-header style="page-copy__header" :heading="$t('pages.auth.verify_email.activating')"></common-page-header>
    </auth-layout>
</template>

<script>
    import AuthLayout from 'components/layouts/AuthLayout'
    import AuthAPI from 'api/AuthAPI'

    export default {
        components: {
            AuthLayout,
        },
        mounted() {
            const email = this.$route.query.e
            const code = this.$route.query.c
            AuthAPI.verifyEmail({ email, code })
                .then((response) =>
                    this.$router.push({ name: 'auth.login', query: { verified: 'success', email: response.email } }),
                )
                .catch(() => this.$router.push({ name: 'auth.login', query: { verified: 'error' } }))
        },
    }
</script>
